/**
 *
 * KitchenContainer
 *
 */

import React from 'react';
import  '../../../public/styles/static-pages/kitchens.scss';
import Pixels from '../../components/Primitives/pixels';

import KitchenHall from '../../components/KitchensComp/kitchenHall';
import WhatGoes from '../../components/KitchensComp/WhatGoes';
// import BeforeAfter from '../../components/KitchensComp/beforeAfterSlider';
import KitchenBanner from '../../components/KitchensComp/kitchenBanner';
import ConsultationForm from '../../components/Primitives/ConsultForm'
import KitchenStore from '../../components/KitchensComp/kitchenStore';
import ContentEspot from '../../components/Primitives/staticContent';
import  '../../../public/styles/staticPages/staticPages.scss';
import Breadcrumb from '../../components/Breadcrumb/breadcrumb';

import {espotAPI,imagePrefix} from '../../../public/constants/constants';
import apiManager from '../../utils/apiManager';
import OurPromisesBannerData from '../../components/OurPromisesBannerComp/OurPromisesBannerData';
import GSchemas from '../../components/GSchemas/index.js';
import KitchenDescription from '../../components/KitchensComp/KitchenDescription';


export class KitchenContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: null,
      faqData:null,
      isMobile: window.innerWidth <= 767,
      imagePath:'',
      espotName: 'GI_FRANCHISE_ENQUIRY',
      DeskImagePath:'',
      RwdImagePath:'',
    };
  }

  getKitchenFaqData(){
    apiManager
      .get(`${espotAPI}GI_KITCHEN_MODULAR_FAQ`)
      .then(response => {
        const {data} = response || {};
        this.setState({
          faqData: data && data.data,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  getFranchiseEnquireData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const {data} = response || {}
        this.setState({
          DeskImagePath: data && data.data.franchiseImgDesk,
          RwdImagePath: data && data.data.franchiseImgRwd,              
        });
                
      })
      .catch(error => {
        this.setState({
          error,
          // isLoading: false,
        });
      });
      
  }

  componentDidMount() {
    this.getFranchiseEnquireData();
    this.getKitchenFaqData();
  }

  render() {
    {!this.state.isMobile ?
      this.state.imagePath=this.state.DeskImagePath
      :
      this.state.imagePath=this.state.RwdImagePath
    }
    return (
      <>
        
        {/* <ContentEspot espotName={ 'GI_PIXEL_KITCHEN_BODY_START' } /> */}
        <section className="staticpage kitchenContainer">
		   
			 <Pixels espotName= "GI_PIXEL_KITCHEN_META"/>
		  
          <div className="slider">
            <KitchenBanner />
          </div>
          <Breadcrumb {...this.props.match.params} staticName="Kitchen Collections" />
          <GSchemas schemaFaq={this.state.faqData} />
          <ContentEspot espotName="GI_KITCHEN_TYPES" />
          <ContentEspot espotName="GI_DREAM_KITCHEN_STEPS" />
          <ContentEspot espotName="GI_KITCHEN_LAYOUTS" />
          <WhatGoes />
          <KitchenHall />
          {/*
          <BeforeAfter /> */}
          <div className="formContainer rooms-kitchen-form">
			  <ContentEspot espotName="GI_KITCHEN_FORMBACKGROUND_IMG" />
		
			  <div id="consultForm" className="formDetails formDetails-consultForm">
              <h2 className="title">Talk to our design expert.</h2>
              <ConsultationForm source="Kitchen-BAC"/>
			 </div>
		  </div>
          <OurPromisesBannerData mainClassName='godrej-interio-promise-all' titleClassName='title-kitchen'/>
          <ContentEspot espotName="GI_KITCHEN_FAQ" />
          
          <KitchenDescription />
          <ContentEspot espotName="GI_MODULAR_KITCHEN_INTERIOR" />
          <ContentEspot espotName="GI_MODULAR_KITCHEN_12" />
          <ContentEspot espotName="GI_MODULAR_KITCHEN_13" />
          <KitchenStore />

          <div className='FranchiseLinkBanner'>          
            <a href="/franchise-enquiry" className='FranchiseLinkBanner-Desktop'>
              <img src={imagePrefix+this.state.imagePath} alt="Franchise Link Banner"></img>
            </a>
          </div>
        </section>
        {/* <ContentEspot espotName={ 'GI_PIXEL_KITCHEN_BODY_END' } /> */}
      </>
    );
  }
}

export default KitchenContainer;
